import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = { class: "table table-hover" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Claim ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Loss date"),
    /*#__PURE__*/_createElementVNode("th", null, "Loss type"),
    /*#__PURE__*/_createElementVNode("th", null, "Claim devices")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EndUserClaimRow = _resolveComponent("EndUserClaimRow")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card ${_ctx.css}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.claims, (claim) => {
              return (_openBlock(), _createBlock(_component_EndUserClaimRow, {
                key: claim.claim_id,
                claim: claim
              }, null, 8, ["claim"]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}